export default "__VITE_ASSET__787812ae__"